import { Link } from "react-router-dom";
import { BookMarked } from "lucide-react";

export const NavBar = () => {
  return (
    <header
      data-testid="site-navbar"
      className="w-full border-b border-[var(--bw-border)] bg-[var(--bw-bg)]/85 backdrop-blur sticky top-0 z-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-home-link"
          className="flex items-center gap-2 group"
        >
          <BookMarked className="w-5 h-5 text-[var(--bw-accent)] group-hover:rotate-6 transition-transform" />
          <span className="font-serif-display text-2xl tracking-tight leading-none">
            book<span className="text-[var(--bw-accent)]">wrck</span>
          </span>
        </Link>
        <nav className="flex items-center gap-8 text-sm">
          <Link
            to="/"
            data-testid="nav-catalog-link"
            className="hover:text-[var(--bw-accent)] transition-colors"
          >
            Catalog
          </Link>
          <Link
            to="/reviews"
            data-testid="nav-reviews-link"
            className="hover:text-[var(--bw-accent)] transition-colors"
          >
            Reviews
          </Link>
          <Link
            to="/about"
            data-testid="nav-about-link"
            className="hidden sm:inline hover:text-[var(--bw-accent)] transition-colors"
          >
            About
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default NavBar;
